import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface StepButtonsProps {
  onNext: () => void;
  onBack?: () => void;
  nextLabel?: string;
  disabled?: boolean;
}

export const StepButtons: React.FC<StepButtonsProps> = ({ 
  onNext, 
  onBack, 
  nextLabel = "Suivant",
  disabled = false 
}) => {
  return (
    <div className="flex space-x-4">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="btn btn-secondary flex items-center"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Précédent
        </button>
      )}
      <button
        type="button"
        onClick={onNext}
        disabled={disabled}
        className={`btn btn-primary flex-1 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        {nextLabel}
      </button>
    </div>
  );
};